import React from 'react';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';

const FooterCont = styled.div`
    background: #fff;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 8px;
    box-shadow: 0 2px 4px 4px ${COLOR.LIGHTGREY};
    z-index: 100;
`;

interface FooterProps {
    children: any,
}

const Footer: React.FC<FooterProps> = (props: FooterProps) => {
    return (<FooterCont>{props.children}</FooterCont>);
}

export default Footer;